import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'

import ActionsForm from '@/shared/mixins/actionsForm'
import AnalystMixin from '@/store/module/analyst/mixin.js'
import BudgetSystemMixin from '@/store/module/budgetsystem/mixin.js'
import ImportRegulationAutoRepository from '@/shared/http/repositories/regulation/imports/importregulationauto'
import ImportRegulationAutoModel from '@/shared/models/regulation/imports/importregulationautomodel'
import ImportRegulationAutoForms from './importregulationauto-form'
import BusinessTypeRepository from '@/shared/http/repositories/configuration/businesstype'
import SchedulingTypeRepository from '@/shared/http/repositories/configuration/schedulingtype'

import InsuranceMixin from '@/store/module/insurance/mixin.js'

export default {
  name: 'ImportRegulationAuto',
  mixins: [
    ActionsForm,
    InsuranceMixin,
    BudgetSystemMixin,
    AnalystMixin
  ],
  data () {
    return {
      data: ImportRegulationAutoModel,
      form: ImportRegulationAutoForms,
      objList: null,
      objItem: null,
      objListImportLog: null,
      file: ''
    }
  },
  mounted () {
    this.getAllSchedulingType()
  },
  computed: {
    objEdit () {
      return this.objItem
    },
    isValidFilteredData () {
      if (this.filteredData) {
        this.$forceUpdate()
        return this.filteredData
        // return (this.filteredData.filter(item => item.regulationTypeID === '00000000-0000-0000-0000-000000000000'))
      }
      return false
    },
    isValidSpecialFields () {
      if (this.form.description.value.length > 250) {
        return this.form.description.value.indexOf('\n\n') >= 0
      }
      return true
    },
    filteredData () {
      if (this.objList !== null) {
        for (var i = 0; i < this.objList.filter(item => item.sinisterFull !== null && item.isNewVersion).length; i++) {
          this.objList[i].status = true
          this.objList[i].schedulingTypeID = this.form.schedulingTypeID.value
        }
        this.$forceUpdate()
        return this.objList.filter(item => item.sinisterFull !== null)
      }
    },
    getAllInsurer: function () {
      var result = []
      if ((this.insurances) && (this.insurances.count) > 0) {
        var data = this.insurances.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.insuranceID.options = result
      }
      return result
    },
    getAllBudgetSystem: function () {
      var result = []
      if ((this.budgetsystems) && (this.budgetsystems.count) > 0) {
        var data = this.budgetsystems.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.budgetSystemID.options = result
      }
      return result
    },
    getAllAnalyst: function () {
      var result = []
      if ((this.analysts) && (this.analysts.count) > 0) {
        var data = this.analysts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'text': data[i].name, 'value': data[i].id })
          } else {
            result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
          }
        }
        this.form.responsibleID.options = result
      }
      return result
    }
  },
  methods: {
    onLoad () {
      this.getAllInsuranceByArea(process.env.AreaAutos)
      this.getAllBudgetSystems()
      this.getAllAnalysts()
      this.getByDate()
    },
    onLoadAllBusinessType (insuranceID) {
      this.form.businessTypeID.options = []
      if (insuranceID) {
        loading.push()
        BusinessTypeRepository.GetAllByInsuranceID(insuranceID)
          .then((response) => {
            this.form.businessTypeID.options = this.onResultDropdown(response, true)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
      this.form.businessTypeID.value = null
    },
    getInsuranceDescription (obj) {
      if (obj && obj !== '' && obj !== null) {
        return obj.name
      }
      return ''
    },
    clearFields () {
      this.form.insuranceID.value = null
      this.form.businessTypeID.value = null
      this.form.budgetSystemID.value = null
      this.form.responsibleID.value = null
      this.form.description.value = ''
      this.form.schedulingTypeID.value = null
      this.objList = []
      this.objItem = null
    },
    onDelete (obj) {
      this.objList = this.objList.filter(regulation => regulation.sinisterFull !== obj.sinisterFull)
    },
    onEdit (obj) {
      this.objItem = obj
    },
    onChangeInsurance () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllBusinessType(self.form.insuranceID.value)
      }, 500)
    },
    getByDate () {
      var arrRegulationData = []
      this.objListImportLog = []
      arrRegulationData.push({
        actionDate: new Date()
      })
      ImportRegulationAutoRepository.GetByDate(arrRegulationData)
        .then((response) => {
          this.form.actionDate.value = response.data.data.actionDate
          this.form.import.value = response.data.data.import
          this.form.save.value = response.data.data.save
          this.form.error.value = response.data.data.error
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    validateData () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self) && this.isValidSpecialFields) {
        loading.push()

        let regulationDataList = this.form.description.value.split('\n').filter(x => !!x)

        var arrRegulationData = []
        if (regulationDataList !== null) {
          for (let lineData of regulationDataList) {
            arrRegulationData.push({
              description: lineData,
              insuranceID: this.form.insuranceID.value,
              businessTypeID: this.form.businessTypeID.value,
              budgetSystemID: this.form.budgetSystemID.value,
              schedulingTypeID: this.form.schedulingTypeID.value,
              responsibleID: this.form.responsibleID.value
            })
          }
        }
        ImportRegulationAutoRepository.Validate(arrRegulationData)
          .then((response) => {
            this.objList = []
            this.onResultGrid(response)
            this.$refs.alert.ShowSuccess()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        var alertMessage = self.$lang.Common.Alerts.RequiredField
        alertMessage += '\n'
        alertMessage += self.$lang.Imports.Alerts.RequiredNewline
        self.$refs.alert.ShowAlert('warning', alertMessage)
        return false
      }
    },
    validateDataFromExcel (importResult) {
      var self = this
      if (importResult.length > 0) {
        loading.push()
        let regulationDataList = importResult
        var arrRegulationData = []
        if (regulationDataList !== null) {
          for (let lineData of regulationDataList) {
            arrRegulationData.push({
              description: lineData.carInspection + ' ' + lineData.inspectionType + ' ' + lineData.sinister + ' ' + lineData.vehicle + ' ' + lineData.workshop,
              insuranceID: this.form.insuranceID.value,
              businessTypeID: this.form.businessTypeID.value,
              budgetSystemID: this.form.budgetSystemID.value,
              schedulingTypeID: this.form.schedulingTypeID.value,
              responsibleID: this.form.responsibleID.value,
              receiptDate: lineData.receiptDate
            })
          }
        }
        ImportRegulationAutoRepository.Validate(arrRegulationData)
          .then((response) => {
            console.log('validou')
            console.log(response)
            this.objList = []
            this.onResultGrid(response)
            this.$refs.alert.ShowSuccess()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        var alertMessage = self.$lang.Common.Alerts.RequiredField
        alertMessage += '\n'
        alertMessage += self.$lang.Imports.Alerts.RequiredNewline
        self.$refs.alert.ShowAlert('warning', alertMessage)
        return false
      }
    },
    importData () {
      var self = this
      if (this.isValidFilteredData) {
        loading.push()
        ImportRegulationAutoRepository.Import(this.filteredData)
          .then((response) => {
            this.onResultGrid(response)
            this.$refs.alert.ShowSuccess()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        self.$refs.alert.ShowAlert('warning', self.$lang.Common.Alerts.RequiredField)
        return false
      }
    },
    getAllSchedulingType: function () {
      SchedulingTypeRepository.GetAll()
        .then((response) => {
          var result = []
          var type = response.data
          if (type && type.data && type.count > 0) {
            var data = type.data
            for (var i in data) {
              if (data[i].status) {
                result.push({ 'text': data[i].name, 'value': data[i].id })
              } else {
                result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
              }
            }
            this.form.schedulingTypeID.options = result
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onPickFile () {
      var self = this
      if (this.form.insuranceID.value !== null && this.form.insuranceID.value === '469598e8-33fa-46f5-a439-ad406b471bf0') {
        if (this.form.schedulingTypeID.value !== null && this.form.responsibleID.value !== null) {
          this.$refs.fileInput.click()
        } else {
          self.$refs.alert.ShowAlert('warning', self.$lang.Common.Alerts.RequiredField)
        }
      } else {
        self.$refs.alert.ShowAlert('warning', self.$lang.Common.Alerts.RequiredField)
      }
    },
    onFilePicked () {
      this.file = this.$refs.fileInput.files[0]

      let formData = new FormData()
      formData.append('name', 'ExcelTokioModel')
      formData.append('file', this.file)

      ImportRegulationAutoRepository.ImportTokio(formData)
        .then((response) => {
          if (response.data.data.length > 0) {
            this.validateDataFromExcel(response.data.data)
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/imports/importregulationauto.js